export default __webpack_public_path__ + "static/media/03_bath.eb28ca69.webp";